import '../assets/styles/Project.scss';

import mockGTECHMaps from '../assets/images/mockGTECHMaps.png';
import mockUEPvP from '../assets/images/mockUePvP.png';
import mockGCEP from '../assets/images/mockGCEP.png';
import mockKaguEngine from '../assets/images/mockKaguEngine.png';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://github.com/LowLevelDevTeam/GCEP" target="_blank" rel="noreferrer"><img src={mockGCEP} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/LowLevelDevTeam/GCEP" target="_blank" rel="noreferrer"><h2>Gaming Campus Engine Paris</h2></a>
                <p>A collaborative game engine built from scratch, featuring a Vulkan renderer, C++ scripting system, physics integration via Jolt, UI with ImGui, and spatial audio through Miniaudio. (02/2026 - 03/2026)</p>
            </div>
            <div className="project">
                <a href="https://github.com/dark-dylan-dev/KaguEngine" target="_blank" rel="noreferrer"><img src={mockKaguEngine} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/dark-dylan-dev/KaguEngine" target="_blank" rel="noreferrer"><h2>Kagu Engine</h2></a>
                <p>Personal game engine exploring low-level Vulkan rendering - custom render pass management, descriptor set handling, and an ImGui-powered editor interface. (03/2025 - ongoing)</p>
            </div>
            <div className="project">
                <a href="https://github.com/dark-dylan-dev/UE_Networking_PvP" target="_blank" rel="noreferrer"><img src={mockUEPvP} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/dark-dylan-dev/UE_Networking_PvP" target="_blank" rel="noreferrer"><h2>Unreal Engine PvP</h2></a>
                <p>A multiplayer PvP prototype built in UE5, focusing on Unreal's networking model - replication, game state synchronization, and client-server authority. (01/2026)</p>
            </div>
            <div className="project">
                <a href="https://github.com/dark-dylan-dev/Pathfinding_GTECH_Maps" target="_blank" rel="noreferrer"><img src={mockGTECHMaps} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/dark-dylan-dev/Pathfinding_GTECH_Maps" target="_blank" rel="noreferrer"><h2>G.TECH Maps</h2></a>
                <p>A pathfinding visualizer implementing A*, Dijkstra and BFS over real-map-style grids, rendered with SFML and an ImGui debug overlay. (11/2025)</p>
            </div>
        </div>
    </div>
    );
}

export default Project;